import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { beam } from '@styles/colors/themes';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
`;

export const Close = styled.div`
  cursor: pointer;
  height: 20px;
`;

export const Back = styled.img`
  cursor: pointer;
`;

export const Label = styled.h2`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 0;
`;

export const Line = styled.div`
  display: flex;
  align-self: flex-end;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 28px;
`;

interface IConfirm {
  disabled?: boolean;
}

export const Confirm = styled.button<IConfirm>`
  height: 36px;
  padding: 0 16px;
  color: ${({ disabled }) => (disabled ? '#C1C4D6' : '#fff')};
  background-color: ${({ disabled }) => (disabled ? '#EDEFF4' : '#1371fe')};
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;

  &.return {
    background: transparent;
    color: #474d66;
    font-size: 14px;
    font-weight: 500;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &.pictureInputs {
    width: 100%;
  }

  &.search-selectedItems {
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
`;

export const RowLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Button = styled.button`
  display: flex;
  border: 0;
  background-color: transparent;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IInput {
  isError?: boolean;
  isLink?: boolean;
}

export const Input = styled.input<IInput>`
  display: flex;
  width: 331px;
  height: 36px;
  border: 1px solid
    ${({ isError }) => (isError ? beam.border.error : '#d8dae5')};
  border-radius: 8px;
  padding: 10px 12px 10px 12px;
  font-size: 12px;

  color: ${({ isLink }) => (isLink ? beam.color.primaryBlue : '#474d66')};
  text-decoration-line: ${({ isLink }) => (isLink ? 'underline' : 'unset')};

  transition: all 0.2s;

  margin-top: 8px;

  ::placeholder {
    color: #8f95b2;
  }
  &.infoInputs {
    width: 100%;
  }
`;
export const SelectFile = styled.label`
  display: flex;
  width: 90px;
  height: 36px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  color: #696f8c;
  background: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;

  margin-left: -90px;

  ::-webkit-file-upload-button {
    display: none;
  }

  transition: 0.2s;
  :hover {
    filter: brightness(0.9);
  }
`;

export const FileName = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  color: #474d66;
  background: #fff;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  border: 1px solid #d8dae5;
`;

export const IconCloseAwesome = styled(FontAwesomeIcon)`
  position: absolute;
  background: white;
  width: 24px !important;
  padding: 1px 6px;
  right: 0px;
  cursor: pointer;
`;

export const ProfileImg = styled.img`
  width: 62px;
  height: 62px;
  border-radius: 32px;

  margin-right: 24px;
  object-fit: cover;
`;

export const Form = styled.form`
  width: 100%;
`;

interface IDivider {
  height?: string;
  width?: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height || '24px'};
  width: ${({ width }) => width};
`;

export const SpacingDivider = styled.div`
  width: 16px;
`;

export const Description = styled.div`
  font-weight: 400;
  color: #474d66;
  font-size: 14px;
  margin-bottom: 24px;
`;

export const Error = styled.div`
  color: #ea1212;
  font-size: 12px;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 24px;
`;

export const Icon = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  color: #474d66;
`;

export const Item = styled.div`
  display: flex;
  padding: 8px 0px 8px 8px;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  color: ${beam.font.primary};
  cursor: pointer;

  :hover {
    background-color: #f5f7fb;
    border-radius: 4px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin-right: 8px;
`;

export const InputSearch = styled.input`
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 32px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 42px;
  color: #474d66;
  font-size: 14px;
  width: 250px;

  :disabled {
    background-color: #f5f7fb;
  }

  &::placeholder {
    color: #8f95b2;
  }
`;

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 12px;
`;

export const SearchCloseIconContainer = styled.div`
  position: absolute;
  right: 12px;
  cursor: pointer;
  height: 20px;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const HelpToolTipDiv = styled.div`
  display: flex;
  padding: 10px 16px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const HelpToolTipTextDiv = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
`;

export const HelpToolTipIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

interface isActiveProps {
  isActive?: boolean;
  isDisabled?: boolean;
  limitOfLines?: number;
}

export const LabelText = styled.div<isActiveProps>`
  display: flex;
  /* white-space: nowrap; */
  font-weight: 500;
  font-size: 14px;
  color: ${({ isActive }) => (isActive ? '#1B203A' : '#696F8C')};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : 'unset')};

  &.help {
    font-size: 14px;
    font-weight: 500;
    color: #474d66;
    margin-left: 8px;
  }

  &.tabble-header {
    font-size: 12px;
    font-weight: 400;
    color: #8f95b2;
  }

  &.tabble-row {
    font-size: 14px;
    font-weight: 400;
    color: #474d66;
  }

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  height: 100%;
  align-self: flex-end;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr 2fr 1.2fr;
  padding: 0 16px 9px 16px;
  gap: 50px;
  align-items: center;

  border-bottom: 1px solid #e6e8f0;
`;

// Possible duplicate: AddManufacturerDialog.styles
export const TableContent = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr 2fr 1.2fr;
  padding: 16px;
  gap: 50px;
  align-items: center;

  border-bottom: 1px solid #e6e8f0;
  --parent-bg: #fff;
`;

interface ICheckbox {
  border: boolean;
}

export const CheckBox = styled.button`
  display: flex;
  border: 0;
  background-color: transparent;
`;

export const CheckBoxDiv = styled.div<ICheckbox>`
  display: flex;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid ${({ border }) => (border ? '#1371fe' : '#d8dae5')};
  background-color: ${({ border }) => (border ? '#1371fe' : '#ffffff')};
  align-items: center;
  justify-content: center;

  margin-right: 16px;
`;

interface IRadio {
  active: boolean;
}

export const Radio = styled.div<IRadio>`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  border: ${({ active }) =>
    active ? '4px solid #1371fe' : '1px solid #d8dae5'};
  background-color: #fff;
  transition: 0.2s;
`;

interface ITagPlaceholder {
  limitOfLines?: number;
  background?: string;
  color?: string;
}

export const TagPlaceholder = styled.div<ITagPlaceholder>`
  display: flex;
  height: 30px;
  padding: 4px 12px;
  border-radius: 15px;
  background: ${({ background }) => background || '#edeff4'};
  color: ${({ color }) => color || '#474d66'};

  font-size: 14px;
  font-weight: 500;

  & + & {
    margin-left: 8px;
  }

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const LoadMore = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: row;

  margin-top: 8px;
`;

export const LoadingText = styled.div`
  border-radius: 8px;
  margin-right: 8px;
  border: none;
  font-size: 12px;
  color: #696f8c;
  text-align: center;
`;

export const LoadingImg = styled.img`
  height: 14px;
  width: 14px;
`;

export const ProductImg = styled.img`
  width: 24px;
  height: 24px;

  margin-right: 12px;
`;

export const HelpToolTipIconContainer = styled.div`
  height: 20px;
`;

export const SmallTickContainer = styled.div`
  height: 20px;
`;

export const FilterButton = styled.div`
  display: flex;
  margin-left: 8px;
  position: relative;
`;

export const NoManufacturerSelected = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: #696f8c;
  font-style: italic;
  font-size: 14px;
`;
